import React from 'react';
import { Form, Label } from 'semantic-ui-react';
import { Field } from 'formik';
import styled from 'styled-components/macro';

// Mevcut Input stilini koruyoruz
const Input = styled(Form.Input)`
  margin-bottom: 0 !important;
  input::placeholder {
    color: #333 !important;
  }

  &.error input::placeholder {
    color: #9f3a38 !important;
  }
`;

// Password input için göz ikonunu kapsayan Container
const PasswordInputContainer = styled.div`
  position: relative;
  
  .eye-icon {
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 2.67142857em !important;
    cursor: pointer !important;
    z-index: 3 !important;
    margin: 0 !important;
    background: none !important;
    opacity: 0.8 !important;
    border: none !important;
    color: rgba(0, 0, 0, 0.6) !important;
  }
  
  .eye-icon:hover {
    opacity: 1 !important;
  }
  
  // Sol taraftaki icon için (lock vb.) boşluk bırakıyoruz
  input {
    padding-right: 2.67142857em !important;
  }
`;

export class PasswordFormikInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false
    };
  }

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  }

  render() {
    const { name, label, className, ...rest } = this.props;
    const { showPassword } = this.state;

    return (
      <Field
        name={name}
        render={({ field, form }) => {
          let error = form.touched[field.name] && form.errors[field.name];
          return (
            <Form.Field className={className}>
              <label
                css={`
                  height: 25px;
                  line-height: 25px;
                `}
              >
                {label}
                {error && (
                  <Label color="red" size="small" pointing="left">
                    {error}
                  </Label>
                )}
              </label>
              <PasswordInputContainer>
                <Input
                  {...rest}
                  error={!!error}
                  type={showPassword ? 'text' : 'password'}
                  {...field}
                />
                <i 
                  className={`eye-icon icon ${showPassword ? 'eye slash' : 'eye'}`} 
                  onClick={this.togglePasswordVisibility}
                />
              </PasswordInputContainer>
              {error && !label && (
                <Label color="red" size="small" pointing>
                  {error}
                </Label>
              )}
            </Form.Field>
          );
        }}
      />
    );
  }
}

// TrimmedPasswordFormikInput bileşeni - email gibi alanlar için boşlukları kırpar
export class TrimmedPasswordFormikInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false
    };
  }

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  }

  render() {
    const { name, label, className, ...rest } = this.props;
    const { showPassword } = this.state;

    return (
      <Field
        name={name}
        render={({ field, form }) => {
          let error = form.touched[field.name] && form.errors[field.name];
          return (
            <Form.Field className={className}>
              <label
                css={`
                  height: 25px;
                  line-height: 25px;
                `}
              >
                {label}
                {error && (
                  <Label color="red" size="small" pointing="left">
                    {error}
                  </Label>
                )}
              </label>
              <PasswordInputContainer>
                <Input
                  {...rest}
                  error={!!error}
                  type={showPassword ? 'text' : 'password'}
                  {...field}
                  onChange={(e, data) => form.setFieldValue(name, data.value.trim())}
                />
                <i 
                  className={`eye-icon icon ${showPassword ? 'eye slash' : 'eye'}`} 
                  onClick={this.togglePasswordVisibility}
                />
              </PasswordInputContainer>
              {error && !label && (
                <Label color="red" size="small" pointing>
                  {error}
                </Label>
              )}
            </Form.Field>
          );
        }}
      />
    );
  }
}